import type { ApolloError } from "@apollo/client/core";

export function getMessageFromError(err: Error | unknown): string {
  if ((err as ClientError).code === "MESSAGE_TO_USER") {
    return (err as ClientError).message;
  }
  if (
    (err as ApolloError).graphQLErrors?.[0]?.extensions.code ===
    "MESSAGE_TO_USER"
  ) {
    return (err as ApolloError).message;
  }
  if ((err as ApolloError).networkError) {
    return "Não foi possível conectar com o servidor";
  }
  console.error(err);
  return "Erro desconhecido";
}

export class ClientError extends Error {
  code = "MESSAGE_TO_USER";
}
